import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { ShiftType } from '@/features/shiftTemplate/domain/enums/ShiftType'

export class DriverShiftEntity {
  id?: string
  shiftId?: string
  shiftStartDateTime?: string
  shiftDuration?: string
  shiftEndDateTime?: string
  shiftType?: ShiftType
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  createdAt?: string
  deletedAt?: string | null
  releaseRoleType?: RoleType
  releaseReason?: string | null
  releaseCreatedAt?: string | null
  releaserUserId?: string | null
  releaserDisplayName?: string | null
  releaserPhotoUrl?: string | null
  driverShiftReleaseCreatedAt?: string | null
}
